<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex justify-content-between">
        <back-arrow :params="backRouteParams"
                    :title="facture && facture.id ? facture.nom : $t('facture.Add')"
                    :route-back="backRoute"/>
      </div>
      <div class="row">
        <div class="col-md-12">
          <b-card class="mt-2 mb-4 shadow-sm">
            <b-form v-unsave-detector @submit.stop.prevent="onSubmit">

              <div class="row mt-2">
                <div class="col-md-12 ">
                  <div class="bold-text level-two-title main-red-color">
                    {{ $t('Devis') }}
                  </div>
                  <div>
                    <span class="light-blue-color">
                      {{ $t('facture.autoComplete') }}
                    </span>
                  </div>
                </div>

                <div class="col-md-4 mt-3">
                  <b-form-group
                    :invalid-feedback="form.type.invalidFeedback"
                    :label="$t('Travaux') + ' / ' + $t('Honoraires') + '*'"
                    class="medium-label mb-4"
                    label-for="type-input">
                    <b-form-select
                      v-if="!factureId"
                      id="type-input"
                      v-model="form.type.value"
                      :options="this.types"
                      :required="!this.form.honoraire.value"
                      :state="form.type.state"
                      @change="clearForm"
                    >
                    </b-form-select>
                    <div v-else>
                      {{ form.type.value && form.type.text ? form.type.text : "N/A" }}
                    </div>
                  </b-form-group>
                </div>

                <div v-if="form.type.value === 'construction'" class="col-md-4 mt-3">
                  <b-form-group
                    :invalid-feedback="form.construction.invalidFeedback"
                    :label="$t('facture.link.construction')"
                    class="medium-label mb-4"
                    label-for="construction-input">
                    <b-form-select
                      v-if="!factureId"
                      id="construction-input"
                      v-model="form.construction.value"
                      :options="operationConstructions"
                      :required="!this.form.honoraire.value"
                      :state="form.construction.state"
                      @change="onSelectConstruction($event)">
                    </b-form-select>
                    <div v-else>
                      {{ form.construction.value ? form.construction.value.name || form.construction.value : "N/A" }}
                    </div>
                  </b-form-group>
                </div>

                <div v-if="form.type.value === 'honoraire'" class="col-md-4 mt-3">
                  <b-form-group
                    :invalid-feedback="form.honoraire.invalidFeedback"
                    :label="$t('facture.link.honoraire')"
                    class="medium-label mb-4"
                    label-for="honoraire-input">
                    <b-form-select
                      v-if="!factureId"
                      id="honoraire-input"
                      v-model="form.honoraire.value"
                      :options="operationHonoraires"
                      :required="!this.form.construction.value"
                      :state="form.honoraire.state"
                      @change="onSelectHonoraire($event)">
                    </b-form-select>
                    <div v-else>
                      {{ form.honoraire.value ? form.honoraire.value.type || form.honoraire.value : "N/A" }}
                    </div>
                  </b-form-group>
                </div>

                <div v-if="form.type.value" class="col-md-4 mt-3">
                  <b-form-group
                    :invalid-feedback="form.devis.invalidFeedback"
                    :label="$t('facture.link.devis')"
                    class="medium-label mb-4"
                    label-for="devis-input">
                    <b-form-select
                      v-if="!factureId"
                      id="devis-input"
                      v-model="form.devis.value"
                      :options="operationDevis"
                      :disabled="(operationDevis && operationDevis.length === 1 && operationDevis[0].value === -1) || (!operationDevis || operationDevis.length === 0)"
                      :state="form.devis.state"
                      @change="onSelectDevis($event)">
                    </b-form-select>
                    <div v-else>
                      {{
                        form.devis.value && form.devis.value !== -1 ? (form.devis.value.devisText + ` : ${isHT ? form.devis.value.prixHT : form.devis.value.prixTTC} €`) : "N/A"
                      }}
                    </div>
                  </b-form-group>
                </div>

              </div>

              <div v-if="form.devis.value && form.devis.value !== -1" class="row">
                <div class="col-md-12 d-flex align-items-center mb-1">
                  <div class="medium-text mb-1">
                    {{ $t('SchedulePayment') }}
                  </div>
                </div>
                <template v-for="(payment, index) in paymentOptions">
                  <div class="custom-col-small">
                    <b-form-group class=" mt-1">
                      <b-form-radio-group
                        id="radio-group-2"
                        v-model="form.payment.value"
                        :disabled="payment.alreadyUsed"
                        :required="!form.payment.value"
                        name="radio-sub-component"
                        @change="onSelectPayment(payment.value, index)">
                        <b-form-radio :value="payment.value"></b-form-radio>
                      </b-form-radio-group>
                    </b-form-group>
                  </div>
                  <div class="col-md-3">
                    <b-form-group :state="!paymentValidation.invalidPayments.includes(index)">
                      <b-form-input
                        :id="`name-input-${index}`"
                        v-model="payment.value.name"
                        :class="{'is-invalid': paymentValidation.invalidPayments.includes(index)}"
                        :disabled="payment.alreadyUsed"
                        required>
                      </b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-md-2">
                    <b-form-group :state="!paymentValidation.invalidPayments.includes(index)"
                                  label-for="datePayment-input">
                      <datepicker-input
                        :id="`datePayment-input-${index}`"
                        v-model="payment.value.date"
                        :class="{'is-invalid': paymentValidation.invalidPayments.includes(index)}"
                        :disabled="payment.alreadyUsed"
                        required
                        v-on:change="onDateChange(index, payment)">
                      </datepicker-input>
                    </b-form-group>
                  </div>
                  <div class="col-md-2">
                    <b-input-group :state="!paymentValidation.invalidPayments.includes(index)"
                                   label-for="percentage-input">
                      <b-form-input
                        :id="`percentage-input-${index}`"
                        v-model="payment.value.percentageRounded"
                        v-disable-scroll
                        :class="{'is-invalid': paymentValidation.invalidPayments.includes(index)}"
                        :disabled="payment.alreadyUsed"
                        max="100"
                        min="0"
                        required
                        step="any"
                        type="number"
                        @change="updatePaymentTTC(index)"
                        @input="updatePaymentTTC(index)">
                      </b-form-input>
                      <b-input-group-append :class="{'is-invalid': paymentValidation.invalidPayments.includes(index)}">
                        %
                      </b-input-group-append>
                    </b-input-group>
                  </div>

                  <div class="col-md-2">
                    <b-input-group :state="!paymentValidation.invalidPayments.includes(index)"
                                   label-for="payment-ttc-input">
                      <b-form-input
                        :id="`payment-ttc-input-${index}`"
                        v-model="payment.value.amount"
                        v-disable-scroll
                        :class="{'is-invalid': paymentValidation.invalidPayments.includes(index)}"
                        :disabled="payment.alreadyUsed"
                        min="0"
                        required
                        step="any"
                        type="number"
                        @change="updatePaymentPercentage(index)"
                        @input="updatePaymentPercentage(index)">
                      </b-form-input>
                      <b-input-group-append :class="{'is-invalid': paymentValidation.invalidPayments.includes(index)}">
                        € (TTC)
                      </b-input-group-append>
                    </b-input-group>
                  </div>
                  <div v-if="payment.alreadyUsed" class="col-2 main-red-color mt-2">
                    {{$t("Facture déjà associée")}}
                  </div>
                  <div v-else class="col-2 bold-text level-two-title main-red-color mt-1">
                    <trash-icon v-if="!payment.alreadyUsed && paymentOptions && paymentOptions.length > 1"
                                class="cursor-pointer" size="18"
                                @click="confirmRemovePayment(payment)"/>
                  </div>
                  <div class="end-col-custom">
                  </div>
                </template>

                <div v-show="paymentValidation.isTotalPrixTTCValid !== 0" class="col-md-4 mb-2 offset-5">
                  <div v-show="paymentValidation.isTotalPrixTTCValid < 0" class="main-red-color"
                       style="margin-left: 4.5rem">
                    {{ $t('Le montant total est supérieur au montant du devis : ') }}
                    {{ -(paymentValidation.isTotalPrixTTCValid) }}€
                  </div>
                  <div v-show="paymentValidation.isTotalPrixTTCValid > 0" class="main-red-color"
                       style="margin-left: 4.5rem">
                    {{ $t('Le montant total est inférieur au montant du devis : ') }}
                    {{ paymentValidation.isTotalPrixTTCValid }}€
                  </div>
                </div>
                <div v-show="paymentValidation.isMissingDate" class="col-md-4 mb-2 offset-5">
                  <div v-show="paymentValidation.isMissingDate" class="main-red-color"
                       style="margin-left: 4.5rem">
                    {{ $t('Une ou plusieurs dates sont manquantes.') }}
                  </div>
                </div>

                <div class="col-12">
                  <span class="bold-text addLink ml-2" @click="addPayment">+ {{ $t('Add') }}</span>
                </div>
                <div v-if="scheduleInfoMessage" class="col-12 mt-2 info-text">
                  {{ scheduleInfoMessage }}
                </div>
              </div>

              <div class="row mt-2">
                <div class="col-md-12">
                  <div class="bold-text level-two-title my-2 main-red-color">
                    {{ $t('Facture') }}
                  </div>
                </div>

                <div class="col-md-4">
                  <b-form-group
                    :invalid-feedback="form.nom.invalidFeedback"
                    :label="$t('facture.Name')+ '*'"
                    class="medium-label mb-4"
                    label-for="name-input">
                    <b-form-input
                      id="name-input"
                      v-model="form.nom.value"
                      :state="form.nom.state"
                      required
                      type="text">
                    </b-form-input>
                  </b-form-group>
                </div>

                <div class="col-md-4">
                  <b-form-group
                    :invalid-feedback="form.libelle.invalidFeedback"
                    :label="$t('facture.Libelle')"
                    class="medium-label mb-4"
                    label-for="libelle-input">
                    <b-form-input
                      id="libelle-input"
                      v-model="form.libelle.value"
                      :state="form.libelle.state"
                      type="text">
                    </b-form-input>
                  </b-form-group>
                </div>

                <div class="col-md-4">
                  <b-form-group
                    :invalid-feedback="form.issuedDate.invalidFeedback"
                    :label="$t('facture.issued.date')+ '*'"
                    class="medium-label mb-4"
                    label-for="issuedDate-input">
                    <datepicker-input
                      id="issuedDate-input"
                      v-model="form.issuedDate.value"
                      :required="true"
                      :state="form.issuedDate.state">
                    </datepicker-input>
                  </b-form-group>
                </div>

                <div class="col-md-4">
                  <b-form-group
                    :invalid-feedback="form.prixTTC.invalidFeedback"
                    :label="$t(`facture.Prix${isHT ? 'HT':'TTC'}`) + '*'"
                    class="medium-label mb-4"
                    label-for="prixTTC-input">
                    <b-input-group>
                      <b-form-input
                        id="prixTTC-input"
                        v-model="form.prixTTC.value"
                        v-disable-scroll
                        :state="form.prixTTC.state"
                        min="0"
                        required
                        step="any"
                        type="number">
                      </b-form-input>
                      <b-input-group-append>{{ '€' }}</b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </div>

                <div class="col-md-4">
                  <b-form-group
                    :label="$t('facture.PrixTVA')+ '*'"
                    class="medium-label mb-4"
                    label-for="prixTVA-input">
                    <b-form-select
                      id="prixTVA-input"
                      v-model="form.prixTVA.value"
                      required>
                      <option v-for="option in tauxTVAList" :value="option.value">
                        {{ $t(option.text) }}
                      </option>
                    </b-form-select>
                  </b-form-group>
                </div>

                <div class="offset-4"/>

                <div class="col-md-6">
                  <b-form-group
                    :invalid-feedback="form.status.invalidFeedback"
                    :label="$t('facture.Status')+ '*'"
                    class="medium-label mb-4"
                    label-for="status-input">
                    <b-form-select
                      id="status-input"
                      v-model="form.status.value"
                      required
                      @change="onStatusChange">
                      <option v-for="option in statusFactureList" :value="option.value">
                        {{ $t(option.text) }}
                      </option>
                    </b-form-select>
                  </b-form-group>
                </div>

                <div v-if="form.status.value !== 'PENDING'" class="col-md-6">
                  <b-form-group
                    :invalid-feedback="form.paidDate.invalidFeedback"
                    :label="$t('facture.paid.date')"
                    class="medium-label mb-4"
                    label-for="paidDate-input">
                    <datepicker-input
                      id="paidDate-input"
                      v-model="form.paidDate.value"
                      :disabled="form.status.value!=='PAID'"
                      :state="form.paidDate.state">
                    </datepicker-input>
                  </b-form-group>
                </div>
                <div v-else class="col-md-6">
                  <!-- Espace réservé pour maintenir l'alignement quand le champ date de paiement est masqué -->
                </div>

                <div class="col-md-4">
                  <multi-file-field
                    :label="$t('Documents').toString()"
                    :new-files-list="newDocumentsList"
                    :old-files-list="oldDocumentsList"
                    @addFiles="addDocuments"
                    @removeNewFile="removeNewDocument"
                    @removeOldFile="removeOldDocument"/>
                </div>
              </div>
              <div class="d-flex justify-content-end">
                <b-button id="validate-btn" type="submit" variant="primary">{{ $t('Validate') }}</b-button>
              </div>
            </b-form>
          </b-card>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import api from '../../services/api'
import BackArrow from '../../components/b122/BackArrow'
import MultiFileField from "../../components/b122/editFields/MultiFileField";
import DatepickerInput from "../../components/b122/editFields/DatepickerInput.vue";
import Vue from "vue";
import Swal from "sweetalert2";

export default {
  name: 'OperationFactureCreateEdit',
  components: {
    BackArrow,
    MultiFileField,
    DatepickerInput
  },
  data() {
    return {
      isHT: false,
      initializedPayments: new Set(),
      paymentValidation: {
        totalPercentage: 100,
        invalidPayments: [],
        isTotalPrixTTCValid: 0,
        isMissingDate : false
      },
      scheduleInfoMessage: null,
      factureId: this.$route.params.factureId,
      operationId: this.$route.params.operationId,
      facture: {},
      documents: [],
      options: [],
      schedule: {},
      newDocumentsList: [],
      oldDocumentsList: [],
      types: [
        {value: 'construction', text: this.$t('Travaux')},
        {value: 'honoraire', text: this.$t('Honoraires')}
      ],
      askConfirm: false,
      tauxTVAList: [],
      statusFactureList: [],
      operationConstructions: [],
      operationHonoraires: [],
      operationDevis: [],
      paymentOptions: [],
      scheduleId: null,
      selectedIndex: -1,
      form: {
        type: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        construction: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        honoraire: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        devis: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        payment: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        prixTTC: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        prixTVA: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        nom: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        issuedDate: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        paidDate: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        status: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        libelle: {
          state: null,
          invalidFeedback: null,
          value: null
        }
      }
    }
  },
  computed: {
    isConstructionSelected() {
      //return this.form.construction.value && this.form.construction.value.hasOwnProperty('id') && this.form.construction.value.id
    },

    backRoute() {
      const from = this.$route.query.from

      switch (from) {
        case 'OperationDevisFacturesIndex':
          return 'OperationDevisFacturesIndex'
        case 'OperationConstructionComponent':
          return null
        case 'OperationFactureShow':
          return 'OperationDevisFacturesIndex'
        default:

          const defaultRoute = this.factureId ? 'OperationDevisFacturesIndex' : 'OperationFactureIndex'
          return defaultRoute
      }
    },

    backRouteParams() {
      let params = { operationId: this.operationId }

      if (this.backRoute === 'OperationFactureShow' && this.factureId) {
        params.factureId = this.factureId
      }

      return params
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {

    clearForm(){
      this.form.construction.value = null
      this.form.honoraire.value = null
      this.form.devis.value = null
      this.form.payment.value = null
      this.form.prixTTC.value = null
      this.form.prixTVA.value = null
      this.form.nom.value = null
      this.form.issuedDate.value = null
      this.form.paidDate.value = null
      this.form.status.value = null
      this.form.libelle.value = null
      this.newDocumentsList = []
      this.oldDocumentsList = []
      this.paymentOptions = []
      this.scheduleId = null
      this.selectedIndex = -1
    },


    async fetchData() {
      await this.getOperation()
      await this.getTauxTVA()
      await this.getStatusFacture()
      await this.getOperationConstructions()
      await this.getOperationHonoraires()

      if (this.factureId) {
        await this.fetchFacture()
        await this.setInitialValues()
        if (this.form.payment.value) {
          await this.getInfoObjectAndAdevis()
        }
        this.form.prixTTC.value = this.isHT ? this.facture.prixHT : this.facture.prixTTC
        this.$forceUpdate()
      }
    },

    async getOperation() {
      if (this.operationId != null) {
        await api
          .get(`/operation/${this.operationId}`)
          .then(response => {
            this.isHT = response.data.isHT
          })
      }
    },


    async getTauxTVA() {
      await api
        .get(`/operation/getTauxTVA`)
        .then(response => {
          this.tauxTVAList = response.data
        })
    },

    async fetchFacture() {

      await api.get(`/facturePayment/${this.factureId}`)
        .then(response => {
          this.facture = response.data
        })
        .catch((error) => {
          this.$router.push({
            name: 'OperationShow',
            params: {
              operationId: this.operationId,
              currentSection: 2,
              message: error.response.data.message
            }
          })
        })
    },
    async setInitialValues() {
      if (this.facture && this.facture.id) {
        this.form.nom.value = this.facture.nom
        this.form.prixTTC.value = this.isHT ?  this.facture.prixHT : this.facture.prixTTC
        this.form.prixTVA.value = this.facture.prixTVA
        this.form.issuedDate.value = this.facture.issuedDate
        this.form.paidDate.value = this.facture.paidDate
        this.form.status.value = this.facture.status
        this.form.libelle.value = this.facture.libelle
        if (this.facture.operationConstruction && this.facture.operationConstruction.id) {
          this.form.construction.value = this.facture.operationConstruction
          await this.fetchOperationDevis(this.facture.operationConstruction.id, 'operationConstruction',true)
          this.form.type = this.types.find(type => type.value === 'construction')
        } else if (this.facture.operationHonoraire && this.facture.operationHonoraire.id) {
          this.form.honoraire.value = this.facture.operationHonoraire
          await this.fetchOperationDevis(this.facture.operationHonoraire.id, 'operationHonoraire',true)
          this.form.type = this.types.find(type => type.value === 'honoraire')
        }
        else if(this.facture.devis){
          this.form.type = this.types.find(type => type.value === this.facture.devis.objLinked)
        }
        if (this.facture.paymentDevis && this.facture.paymentDevis.id) {
          this.form.payment.value = this.facture.paymentDevis
        }
        this.oldDocumentsList = this.facture.documents
      }
    },
    async onSelectConstruction(construction) {
      this.form.honoraire.value = null;
      this.form.construction.value = construction;
      this.form.devis.value = null;
      this.form.payment.value = null;
      this.form.nom.value = construction.name;
      this.form.prixTTC.value = construction.hasOwnProperty('totalPrixTTC') && construction.totalPrixTTC ? construction.totalPrixTTC : construction.prixTTC;
      this.form.issuedDate.value = new Date().toISOString().split('T')[0];
      this.form.prixTVA.value = construction.tauxTVA
      await this.fetchOperationDevis(construction.id, 'operationConstruction');
      if(this.form.devis.value === -1 && this.operationDevis.find(devis => devis.text === 'Dépassement de devis')){
        this.form.libelle.value = "Dépassement de devis"
      }
    },
    async onSelectHonoraire(honoraire) {
      this.form.construction.value = null;
      this.form.honoraire.value = honoraire;
      this.form.devis.value = null;
      this.form.payment.value = null;
      this.form.nom.value = honoraire.type;
      this.form.prixTTC.value = honoraire.hasOwnProperty('totalPrixTTC') && honoraire.totalPrixTTC ? honoraire.totalPrixTTC : honoraire.prixTTC;
      this.form.prixTVA.value = this.tauxTVAList[0] ? this.tauxTVAList[0].value : "20%";
      this.form.issuedDate.value = new Date().toISOString().split('T')[0];
      await this.fetchOperationDevis(honoraire.id, 'operationHonoraire');
      if(this.form.devis.value === -1 && this.operationDevis.find(devis => devis.text === 'Dépassement de devis')){
        this.form.libelle.value = "Dépassement de devis"
      }
    },
    async onSelectDevis(devis) {
      this.form.devis.value = devis;
      this.form.payment.value = null;
      this.form.prixTTC.value = this.isHT ? devis.prixHT : devis.prixTTC;
      this.form.prixTVA.value = devis.tauxTVA;
      if (devis.operationConstruction && devis.operationConstruction.id) {
        this.form.nom.value = devis.operationConstruction.name + ' - ' + devis.artisan.toString;
      } else if (devis.operationHonoraire && devis.operationHonoraire.id) {
        this.form.nom.value = devis.operationHonoraire.type + ' - ' + devis.artisan.toString;
      }
      if(this.form.devis.value === -1 && this.operationDevis.find(devis => devis.text === 'Dépassement de devis')){
        this.form.libelle.value = "Dépassement de devis"
      }
      if(devis === -1) {
        this.scheduleId = -1;
      }
      if(devis && devis.id){
        await this.fetchPaymentOptions(devis.id);
      }
    },
    async fetchOperationDevis(id, type = 'construction', initializeValue = false) {
      let data = new FormData();
      data.append('id', id);
      data.append('type', type);
      await api.post(`/operationDevis/getAllForObjectLinked`, data)
        .then(response => {
          this.operationDevis = response.data.map(devis => ({
            value: devis,
            text: ((devis.numero && devis.numero !== 'null' ? `${devis.artisan.toString} - ${devis.numero}` : `${devis.artisan.toString}`) + (devis.schedule && devis.schedule.id && devis.schedule.unUsedPaiements && devis.schedule.unUsedPaiements.length === 0 ? ` - ${this.isHT ? devis.prixHT : devis.prixTTC}€ - (Désactivé)` : ` - ${this.isHT ? devis.prixHT : devis.prixTTC}€`)),
            disabled: devis.schedule && devis.schedule.id && devis.schedule.unUsedPaiements && devis.schedule.unUsedPaiements.length === 0
          }));
          if (this.operationDevis.length === 0) {
            this.form.devis.value = -1;
            this.scheduleId = -1;
            this.operationDevis.splice(0, 0, {value: -1, text: 'Pas de devis',disabled:true});
          } else {
            this.operationDevis.splice(this.operationDevis.length, 0, {value: -1, text: 'Dépassement de devis', disabled:false});
            const firstEnabledDevis = this.operationDevis.find(devis => !devis.disabled);
            if (firstEnabledDevis && !initializeValue) {
              this.form.devis.value = firstEnabledDevis.value;
            }
            this.onSelectDevis(this.form.devis.value);
          }
        })
        .catch(error => {
          console.error('Error fetching operation devis:', error);
        });
    },

    async fetchPaymentOptions(devisId) {
      await api.get(`/operationDevis/getPaymentsForDevis/${devisId}`)
        .then(response => {
          let totalAmount = this.form.devis.value.prixTTC;
          if(this.isHT){
            totalAmount = this.form.devis.value.prixHT
          }
          this.scheduleId = response.data.id;
          this.paymentOptions = response.data.paiements.map(payment => {
            const alreadyUsed = !!(payment.facture && payment.facture.id && payment.facture.id !== this.facture.id);
            const percentage = totalAmount ? this.roundToTwo((payment.amount / totalAmount) * 100) : 0;
            return {
              alreadyUsed: alreadyUsed,
              value: {
                ...payment,
                percentageRounded: percentage,
                percentage: percentage
              },
              text: `${payment.name} le ${payment.date.split('-').reverse().join('/')} : ${this.formatEuro(payment.amount)}`
            };
          });

          this.selectedIndex = null;

          for (let index = 0; index < this.paymentOptions.length; index++) {
            const paymentOption = this.paymentOptions[index];
            const payment = paymentOption.value;

            if (this.form.payment.value && this.form.payment.value.id === payment.id) {
              this.selectedIndex = index;
              this.form.payment.value = payment;
              break;
            } else if (!paymentOption.alreadyUsed && (!this.form.payment.value || !this.form.payment.value.hasOwnProperty('id'))) {
              this.selectedIndex = index;
              this.form.payment.value = payment;
              this.form.prixTTC.value = payment.amount;
              this.form.issuedDate.value = payment.date;
              this.form.libelle.value = `${payment.name} le ${payment.date.split('-').reverse().join('/')} : ${this.formatEuro(payment.amount)}`;
              break;
            }
          }

          if (this.paymentOptions.length > 0) {
            this.updatePaymentPercentage(0);
          }
        });
    },


    onSelectPayment(payment, index) {
      this.selectedIndex = index;
      this.form.payment.value = payment;
      this.form.prixTTC.value = payment.amount;
      this.form.issuedDate.value = payment.date;
      this.form.libelle.value = `${payment.name} le ${payment.date.split('-').reverse().join('/')} : ${this.formatEuro(payment.amount)}`;
    },

    onStatusChange() {
      if (this.form.status.value === 'PAID') {
        this.form.paidDate.value = this.form.issuedDate.value;
      } else {
        this.form.paidDate.value = null;
      }
    },

    formatEuro(value) {
      if (!value && value !== 0) return 'N/A';
      const formatter = new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR',
      });
      return formatter.format(value);
    },

    roundToTwo(num) {
      return +(Math.round(num + "e+2") + "e-2");
    },

    async getStatusFacture() {
      await api.get(`/facturePayment/getStatusFacture`)
        .then(response => {
          this.statusFactureList = response.data
        })
    },

    async getOperationHonoraires() {
      if (this.operationId != null) {
        await api.get(`/operationHonoraire/getAllForOperationWithoutUse/${this.operationId}`)
          .then(response => {
            const generalGroup = { label: 'Général', options: [] };
            const lotsGroupMap = new Map();
            const lotGroupsGroupMap = new Map();
            const honorairesMap = new Map();

            response.data.forEach(honoraire => {
              if (honoraire['date'] != null) {
                let dateLong = Number(honoraire['date']);
                honoraire['date'] = new Date(dateLong).toLocaleDateString().split("/").reverse().join("-");
              }

              const uniqueId = honoraire.commonId || honoraire.id;

              if (!honorairesMap.has(uniqueId)) {
                if (honoraire.commonId) {
                  if (!honoraire.operation.id) {
                    const relatedHonoraires = response.data.filter(
                      h => h.commonId === honoraire.commonId
                    );

                    const lots = relatedHonoraires.map(h => h.operationLot.tostring).filter(Boolean);
                    const mainLot = lots[0] || 'Inconnu';
                    const label = lots.length > 1 ? `${mainLot} + (${lots.length - 1} lots concernés)` : mainLot;

                    if (!lotGroupsGroupMap.has(honoraire.commonId)) {
                      lotGroupsGroupMap.set(honoraire.commonId, { label, options: [] });
                    }

                    lotGroupsGroupMap.get(honoraire.commonId).options.push({
                      value: honoraire,
                      text: honoraire.tostring,
                    });
                  }
                } else if (honoraire.operation.id) {

                  generalGroup.options.push({
                    value: honoraire,
                    text: honoraire.tostring,
                  });
                } else {
                  const lotName = honoraire.operationLot ? honoraire.operationLot.tostring : 'Inconnu';
                  if (!lotsGroupMap.has(lotName)) {
                    lotsGroupMap.set(lotName, { label: lotName, options: [] });
                  }

                  lotsGroupMap.get(lotName).options.push({
                    value: honoraire,
                    text: honoraire.tostring,
                  });
                }

                honorairesMap.set(uniqueId, true);
              }
            });

            const options = [];

            if (generalGroup.options.length > 0) {
              options.push(generalGroup);
            }

            lotGroupsGroupMap.forEach(group => {
              if (group.options.length > 0) {
                options.push(group);
              }
            });

            lotsGroupMap.forEach(group => {
              if (group.options.length > 0) {
                options.push(group);
              }
            });

            this.operationHonoraires = options;
          });
      }
    },

    async getOperationConstructions() {
      if (this.operationId != null) {
        await api.get(`/operationConstruction/getAllForOperation/${this.operationId}`)
          .then(response => {
            const generalGroup = { label: 'Général', options: [] };
            const lotsGroupMap = new Map();
            const lotGroupsGroupMap = new Map();
            const constructionMap = new Map();

            response.data.forEach(construction => {
              if (construction['date'] != null) {
                let dateLong = Number(construction['date']);
                construction['date'] = new Date(dateLong).toLocaleDateString().split("/").reverse().join("-");
              }

              const uniqueId = construction.commonId || construction.id;

              if (!constructionMap.has(uniqueId)) {
                if (construction.commonId) {

                  if (!construction.operation.id) {
                    const relatedConstructions = response.data.filter(
                      c => c.commonId === construction.commonId
                    );

                    const lots = relatedConstructions.map(c => c.operationLot.tostring).filter(Boolean);
                    const mainLot = lots[0] || 'Inconnu';
                    const label = lots.length > 1 ? `${mainLot} + (${lots.length - 1} lots concernés)` : mainLot;

                    if (!lotGroupsGroupMap.has(construction.commonId)) {
                      lotGroupsGroupMap.set(construction.commonId, { label, options: [] });
                    }

                    lotGroupsGroupMap.get(construction.commonId).options.push({
                      value: construction,
                      text: construction.tostring,
                    });
                  }
                } else if (construction.operation.id) {

                  generalGroup.options.push({
                    value: construction,
                    text: construction.tostring,
                  });
                } else {

                  const lotName = construction.operationLot ? construction.operationLot.tostring : 'Inconnu';
                  if (!lotsGroupMap.has(lotName)) {
                    lotsGroupMap.set(lotName, { label: lotName, options: [] });
                  }

                  lotsGroupMap.get(lotName).options.push({
                    value: construction,
                    text: construction.tostring,
                  });
                }

                constructionMap.set(uniqueId, true);
              }
            });

            const options = [];

            if (generalGroup.options.length > 0) {
              options.push(generalGroup);
            }

            lotGroupsGroupMap.forEach(group => {
              if (group.options.length > 0) {
                options.push(group);
              }
            });

            lotsGroupMap.forEach(group => {
              if (group.options.length > 0) {
                options.push(group);
              }
            });


            this.operationConstructions = options;
          });
      }
    },

    async getInfoObjectAndAdevis() {
      await api.get(`/facturePayment/getInfoObjectAndAdevis/${this.factureId}`)
        .then(response => {
          this.form.construction.value = response.data.operationConstruction
          this.form.honoraire.value = response.data.operationHonoraire
          this.form.devis.value = response.data.operationDevis
          this.fetchPaymentOptions(response.data.operationDevisId)
        });
    },


    addDocuments(files) {
      files.forEach(file => {
        if (file) {
          this.newDocumentsList.push(file)
        }
      })
    },

    removeNewDocument(file) {
      this.newDocumentsList.splice(this.newDocumentsList.indexOf(file), 1)
    },

    removeOldDocument(file) {
      this.oldDocumentsList.splice(this.oldDocumentsList.indexOf(file), 1)
      this.documents.splice(this.documents.indexOf(file), 1)
      this.newDocumentsList.splice(this.newDocumentsList.indexOf(file), 1)
      if (file.id) {
        api.delete(`/facturePayment/deleteFileFacture/${file.id}`)
      }
    },

    successToast(operationName) {
      this.$bvToast.toast(operationName, {
        autoHideDelay: 4000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: "success",
        solid: true,
      })
    },

    async saveOrUpdateNewPayments() {
      for (const payment of this.paymentOptions) {
        let data = new FormData();
        if (payment.value.id) {
          data.append('id', payment.value.id);
        }
        let prixTTCToSend = payment.value.amount
        if (this.isHT && payment.value.amount) {
          const taux = parseFloat(this.form.devis.value.tauxTVA.replace('%', '')) / 100
          prixTTCToSend = this.roundToTwo(payment.value.amount * (1 + taux))
        }

        data.append('amount', prixTTCToSend);
        data.append('date', payment.value.date);
        data.append('name', payment.value.name);
        data.append('scheduleId', this.scheduleId);

        try {
          const response = await api({
            method: 'POST',
            url: `/scheduleDevis/saveUpdatePaymentDevis/${this.scheduleId}`,
            data: data
          });

          payment.value.id = response.data.id;
        } catch (error) {
          console.error('Error saving payment:', error);
          throw new Error('Error saving payment');
        }
      }
    },


    async onSubmit() {
      const isFormInvalid = Object.values(this.form).some(field => field.state === false);
      this.validatePayments()
      if (isFormInvalid || (this.scheduleId && this.scheduleId > 0 && this.paymentValidation.isTotalPrixTTCValid != 0) || !this.form.issuedDate.value || this.paymentValidation.isMissingDate ) {
        this.errorToast()
        return;
      }

      let updateFacture = false
      let needPopUp = false
      let message = `En ajoutant cette facture, vous allez dépasser le montant des ${this.form.construction && this.form.construction.value ? "travaux" : "honoraires"}, qui sera automatiquement mis à jour.`
      if (this.form.devis.value === -1) {
        if (this.scheduleId && this.scheduleId < 0 && this.form.construction.value && this.form.prixTTC.value > this.form.construction.value.prixTTC) {
          needPopUp = true;
        }
        else if (this.scheduleId && this.scheduleId < 0 && this.form.honoraire.value && this.form.prixTTC.value > this.form.honoraire.value.prixTTC) {
          needPopUp = true;
        }
        else if(this.scheduleId && this.scheduleId < 0 && this.operationDevis.find(devis => devis.text === 'Dépassement de devis')){
          needPopUp = true;
        }
      } else {
        if(this.scheduleId && this.scheduleId > 0 && this.paymentOptions[this.selectedIndex].value.amount !== this.form.prixTTC.value) {
          needPopUp = true;
          message = "Le montant de votre facture est différent du montant de l'échéance sélectionnée.";
        }
      }

      if(needPopUp){
        await Swal.fire({
          title: "Confirmez-vous cette action ?",
          text: message,
          showCancelButton: true,
          cancelButtonText: "Non",
          confirmButtonText: "Oui",
          reverseButtons: true
        }).then((result) => {
          if (result.value) {
            updateFacture = true
          }
        });
      }
      if(updateFacture || !needPopUp){
        try {
          if (this.scheduleId && this.scheduleId > 0) {
            await this.saveOrUpdateNewPayments();
          }
        } catch (error) {
          console.error('Error in saveOrUpdateNewPayments:', error);
          return;
        }

        let prixTTCToSend = this.form.prixTTC.value
        if (this.isHT && this.form.prixTVA.value) {
          const taux = parseFloat(this.form.prixTVA.value.replace('%', '')) / 100
          prixTTCToSend = this.roundToTwo(this.form.prixTTC.value * (1 + taux))
        }

        let data = new FormData()
        data.append('updateConstruction', true)

        if (this.form.construction.value && this.form.construction.value.hasOwnProperty('id') && this.form.construction.value.id) {
          data.append('construction', this.form.construction.value.id)
        }
        if (this.form.honoraire.value && this.form.honoraire.value.hasOwnProperty('id') && this.form.honoraire.value.id) {
          data.append('honoraire', this.form.honoraire.value.id)
        }
        if (this.form.devis.value && this.form.devis.value.hasOwnProperty('id') && this.form.devis.value.id) {
          data.append('devis', this.form.devis.value.id)
        }
        if (this.form.payment.value && this.form.payment.value.hasOwnProperty('id') && this.form.payment.value.id) {
          data.append('payment', this.form.payment.value.id)
        }
        data.append('nom', this.form.nom.value)
        data.append('prixTTC', prixTTCToSend)
        data.append('prixTVA', this.form.prixTVA.value)
        data.append('status', this.form.status.value)
        data.append('issuedDate', this.form.issuedDate.value)

        if (this.form.status.value !== 'PENDING' && this.form.paidDate.value) {
          data.append('paidDate', this.form.paidDate.value)
        } else {
          data.append('paidDate', null)
        }
        if (this.form.libelle.value) {
          data.append('libelle', this.form.libelle.value)
        }
        if (this.newDocumentsList && this.newDocumentsList.length > 0) {
          data.append('nbFile', this.newDocumentsList.length)
        } else {
          data.append('nbFile', 0)
        }
        this.newDocumentsList.forEach((file, index) => {
          data.append(`file[${index}]`, file)
        })
        if (this.scheduleId && this.paymentOptions && this.paymentOptions.length > 0) {
          data.append('scheduleId', this.scheduleId)
          const paymentValues = this.paymentOptions.map(payment => payment.value);
          data.append('payments', JSON.stringify(paymentValues));
        }

        api({
          method: this.facture.id ? 'PUT' : 'POST',
          url: this.facture.id ? `facturePayment/${this.facture.id}` : 'facturePayment',
          data: data
        })
          .then(async response => {

            if (!this.factureId && response.data && response.data.id) {
              this.factureId = response.data.id
            }

            await this.generateMonthlyCharges()

            let routeParams = { operationId: this.operationId }
            if (this.backRoute === 'OperationFactureShow' && this.factureId) {
              routeParams.factureId = this.factureId
            }

            this.$router.go(-1)
            this.$nextTick(() => {
              if (this.facture.id) {
                this.successToast(this.$i18n.t('Facture') + ' "' + this.form.nom.value + '" ' + this.$i18n.t('f.modified'))
              } else {
                this.successToast(this.$i18n.t('Facture') + ' "' + this.form.nom.value + '" ' + this.$i18n.t('f.added'))
              }
            })

          })
          .catch((error) => {
            if (error.response.status === 401 || error.response.status === 404) {
              this.$router.push({
                name: this.backRoute,
                params: {
                  message: error.response.data.message,
                  operationId: this.operationId,
                }
              })
            } else if (error.response.status === 403) {
              const invalidField = error.response.data.invalidField
              this.form[invalidField]['state'] = false
              this.form[invalidField]['invalidFeedback'] = this.$i18n.t(error.response.data.message)
            }
          })
      }
    },

    async generateMonthlyCharges() {

      let data = new FormData()
      data.append('operationId', this.operationId)

      api({
        method: 'POST',
        url: '/treasury/generateMonthlyCharges',
        data: data
      })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'OperationShow',
              params: {
                operationId: this.operationId,
                currentSection: 2,
                message: error.response.data.message
              }
            })
          }
        })
    },


    confirmRemovePayment(payment) {
      if (payment.alreadyUsed) {
        this.$alert(this.$t('facture.cant.delete.payment').toString()).then(() => {
        });
      } else {
        this.removePayment(payment);
      }
    },

    removePayment(paymentToRemove) {
      this.paymentOptions = this.paymentOptions.filter(payment => payment !== paymentToRemove);
      this.validatePayments()
    },

    addPayment() {
      if (this.paymentValidation.isTotalPrixTTCValid > 0) {
        const newPayment =
          {
            value: {
              id: null,
              name: '',
              date: null,
              percentage: 0,
              percentageRounded: 0,
              amount: 0
            }
          };

        this.paymentOptions.push(newPayment);
        this.validatePayments();
      } else {
        this.scheduleInfoMessage = this.$i18n.t('Montant total du devis déjà atteint').toString()
        setTimeout(() => { this.scheduleInfoMessage = null }, 3000)
      }
    },


    updatePaymentTTC(index) {
      const payment = this.paymentOptions[index];
      if (payment.alreadyUsed) return;
      let amountDevis = this.form.devis.value.prixTTC
      if(this.isHT){
        amountDevis = this.form.devis.value.prixHT
      }

      payment.value.percentage = payment.value.percentageRounded || 0;
      if (payment.value.percentage && amountDevis) {
        payment.value.amount = this.roundToTwo((payment.value.percentage / 100) * amountDevis);
      }
      this.validatePayments(index);
      if (this.selectedIndex >= 0) {
        this.form.prixTTC.value = this.paymentOptions[this.selectedIndex].value.amount
      }
    },

    onDateChange(index, payment) {
      if (!this.initializedPayments.has(index)) {
        this.initializedPayments.add(index)
        return
      }
      this.updateDate(index, payment)
    },

    updateDate(index, payment){
      if(this.selectedIndex === index){
        this.form.issuedDate.value = payment.value.date;
      }
      this.validatePayments(index)
    },

    updatePaymentPercentage(index) {
      const payment = this.paymentOptions[index];
      if (payment.alreadyUsed) return;

      let amountDevis = this.form.devis.value.prixTTC
      if(this.isHT){
        amountDevis = this.form.devis.value.prixHT
      }

      payment.value.amount = payment.value.amount || 0;
      if (payment.value.amount && amountDevis) {
        payment.value.percentageRounded = this.roundToTwo((payment.value.amount / amountDevis) * 100);
        payment.value.percentage = (payment.value.amount / amountDevis) * 100;
      }

      this.validatePayments(index);
      if (this.selectedIndex >= 0 && !payment.value.facture) {
        this.form.prixTTC.value = this.paymentOptions[this.selectedIndex].value.amount
      }
    },

    validatePayments() {
      let totalAmount = this.paymentOptions.reduce((total, payment) => total + (parseFloat(payment.value.amount) || 0), 0);

      let formPrixTTCValue = this.form.devis.value && this.form.devis.value.hasOwnProperty('prixTTC') ? parseFloat(this.form.devis.value.prixTTC) : 0;
      if(this.isHT && formPrixTTCValue && formPrixTTCValue > 0){
        formPrixTTCValue = parseFloat(this.form.devis.value.prixHT);
      }

      this.paymentValidation.isTotalPrixTTCValid = (formPrixTTCValue - totalAmount).toFixed(2);
      this.paymentValidation.isMissingDate = this.paymentOptions.some(payment => !payment.value.date);

      this.$forceUpdate();

      return this.paymentValidation.isTotalPrixTTCValid;
    },

    managePrixTTC() {
      this.paymentOptions[this.selectedIndex].value.amount = this.form.prixTTC.value
      this.updatePaymentPercentage(this.selectedIndex);
    },

    errorToast() {
      this.$bvToast.toast(this.$i18n.t('MandatoryFields'), {
        autoHideDelay: 5000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: "danger",
        solid: true,
      })
    }
  }
}
</script>

<style scoped>
.custom-col-small {
  -ms-flex: 0 0 3%;
  -webkit-box-flex: 0;
  flex: 0 0 3%;
  max-width: 3%;
  margin-left: 2em;
}

.end-col-custom {
  -ms-flex: 0 0 3%;
  -webkit-box-flex: 0;
  flex: 0 0 3%;
  max-width: 3%;
}

.info-text{
  color: #07153C !important;
  font-style: italic;
}

</style>



// WEBPACK FOOTER //
// src/views/OperationFacture/OperationFactureCreateEdit.vue